import { useAppSelector } from 'app/hooks';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound: FC = () => {
    const {
        userInfo: { isLoggedIn },
    } = useAppSelector((state) => state.auth);
    const navigate = useNavigate();

    useEffect(() => {
        // if not logged in, let it be handled by Auth component
        if (isLoggedIn) {
            navigate('/');
        }
    }, [isLoggedIn, navigate]);

    return null;
};

export default NotFound;
